import styles from "./PushNotificationsPrompt.styles.scss";
import {Body} from "../typography";

const PushNotificationsPrompt = ({ canEnableNotifications, onEnableNotifications }) => {
  return canEnableNotifications ?
    <div className={styles.enableNotifications}>
      <Body size="caption">
        <a className={styles.link} onClick={onEnableNotifications}>
          Habilite notificações
        </a>{" "}
        para receber novas mensagens assim que elas chegarem
      </Body>
    </div> : <div/>
}

export default PushNotificationsPrompt;



// WEBPACK FOOTER //
// ./components/PushNotificationsPrompt/PushNotificationsPrompt.js